import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { PageLayout } from "../../components";
import { useNavigate } from "react-router-dom";
import { ManualEnquiry } from "./ManualEnquiry";
import { schema } from "./schema";

import { getAppraisalData, selectAppraisal } from "../../store/selectors";
import { appraisalSlice } from "../../store/slices/Appraisal";

const ManualEnquiryContainer = () => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const { vehicle } = useSelector(getAppraisalData);
  const { isManual, registrationInput } = useSelector(selectAppraisal);

  const [reg, setReg] = useState(registrationInput);
  const [regRequired, setRegRequired] = useState(false);
  const [regFormatIncorrect, setRegFormatIncorrect] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (vehicle && isManual) {
      navigate("/mileage");
    }
  });

  const onSubmit = async (formData) => {
    const { registration } = formData;
    dispatch(appraisalSlice.actions.setRegistration(registration));
    dispatch(appraisalSlice.actions.clearVehicle());
    navigate(`/mileage?registration=${registration}`);
  };

  const handleSellVan = () =>
    window.location.assign(
      `/value-my-vehicle/sell-my-car/van${
        reg ? `?registration=${reg.toUpperCase()}` : ""
      }`
    );

  return (
    <PageLayout>
      <div className="manual-enquiry">
        <PageLayout.Header title="Manual enquiry" step={1} />
      </div>
      <PageLayout.Content>
        <ManualEnquiry
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          errors={errors}
          register={register}
          reg={reg}
          setReg={setReg}
          handleSellVan={handleSellVan}
          regRequired={regRequired}
          setRegRequired={setRegRequired}
          regFormatIncorrect={regFormatIncorrect}
          setRegFormatIncorrect={setRegFormatIncorrect}
        />
      </PageLayout.Content>
    </PageLayout>
  );
};

export default ManualEnquiryContainer;
